import React, { FC } from 'react';
import classNames from 'classnames';

import { Icon, IconProps, IconSize } from '../Icon';

import styles from './LiveIndicator.module.scss';

export { IconSize };

type LiveIndicatorProps = Omit<IconProps, 'icon'>;

export const LiveIndicator: FC<LiveIndicatorProps> = (props) => {
  return (
    <Icon {...props}
          icon="live"
          className={classNames(styles.indicator, props.className)} />
  );
};
